import React from "react";
import styles from "./styles.scss";
import ScheduleSummary from "./ScheduleSummary";
import ScheduleList from "./ScheduleList";

const SchedulePanel = ({ event }: { event: any }) => {
  return (
    <section className="rotoql-schedule__container">
      <ScheduleSummary event={event} />

      <ScheduleList event={event} />
      <style jsx global>
        {styles}
      </style>
    </section>
  );
};

export default SchedulePanel;
